module.exports = {"511129100":"沐溪镇","511129101":"永福镇","511129102":"大楠镇","511129103":"箭板镇","511129104":"舟坝镇","511129105":"黄丹镇","511129106":"利店镇","511129107":"富新镇","511129205":"底堡乡","511129206":"杨村乡","511129207":"高笋乡","511129208":"茨竹乡","511129210":"武圣乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511129.json
// module id = 2467
// module chunks = 0